import React, { Component } from 'react';
import { connect } from 'react-redux';
import { store } from 'MainApp';
class ModulesContainer extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		if (this.props.modules[this.props.module]) return <div {...this.props}>{this.props.children}</div>;
		return null;
	}
}

function mapStateToProps({ accountSettings }) {
	return { modules: accountSettings.organisationStructure.modules };
}

export default connect(
	mapStateToProps,
	{}
)(ModulesContainer);

export const ifModule = module => {
	const modules = store.getState().accountSettings.organisationStructure.modules;
	if (modules[module]) return true;
	return false;
};



// WEBPACK FOOTER //
// ./containers/ModulesContainer/index.js